import { useState, ComponentPropsWithoutRef } from 'react';
import { useTranslation } from 'next-i18next';
import classNames from 'classnames';
import { Modal, Select, FieldContainer, Input, nanoid } from '@forma/forma-ui-kit';
import RadioButtons from '../RadioButtons';

import styles from './radio-buttons-modal.module.css';
import { ReactSVG } from 'react-svg';

interface RadioButtonsModalProps extends Omit<ComponentPropsWithoutRef<typeof Select>, 'name' | 'options' | 'onChange'> {
  name: string,
  options: { value: string, label: string }[],
  onChange: (value: string) => void,
}

const RadioButtonsModal = ({
  id, name, options, value: initialValue, placeholder, viewStyle, className, onChange, meta
}: RadioButtonsModalProps) => {
  const { t } = useTranslation();
  if (!id) id = nanoid(8);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(initialValue);

  const selectedOption = options.find(option => option.value === value);

  return (
    <FieldContainer id={id}>
      <Input
        id={id}
        value={selectedOption?.label || ''}
        viewStyle={viewStyle}
        className={classNames(className, styles.input)}
        onFocus={() => setOpen(true)}
        onClick={() => setOpen(true)}
        placeholder={String(placeholder)}
        readOnly
        meta={{
          ...meta,
          icon: <ReactSVG src="/icons/chevron-down.svg" wrapper="span" className={styles.arrow} />,
          showIconAlways: true
        }}
      />
      <Modal
        open={open}
        onClose={setOpen}
        title={placeholder}
        buttonsClassName={styles.buttons}
        buttons={[
          {
            viewStyle: 'tertiary',
            children: t('uikit:go_back')
          },
          {
            children: t('uikit:save'),
            disabled: !value,
            onClick: () => {
              onChange(value!);
              setOpen(false);
            }
          }
        ]}
      >
        <RadioButtons
          name={name}
          options={options}
          value={value}
          onChange={e => setValue(e.target.value)}
          containerClass={styles.radio}
        />
      </Modal>
    </FieldContainer>
  );
};

export default RadioButtonsModal;
